import { z } from 'zod';

// A term the translator proposed for the EN↔KR glossary. Pending until a signed-in admin
// decides it; approving appends it to the glossary article. Fields mirror the glossary's
// columns: English · Korean · Gloss · Where used.
export const GLOSSARY_PROPOSAL_STATUSES = ['pending', 'approved', 'rejected'] as const;
export const GlossaryProposalStatusSchema = z.enum(GLOSSARY_PROPOSAL_STATUSES);
export type GlossaryProposalStatus = z.infer<typeof GlossaryProposalStatusSchema>;

export const GlossaryProposalSchema = z.object({
  id: z.uuid(),
  en: z.string(),
  ko: z.string(),
  gloss: z.string(),
  whereUsed: z.string().nullable(),
  status: GlossaryProposalStatusSchema,
  sessionId: z.uuid().nullable(),
  // The Slack message the term came from, when the gateway announced it.
  sourceUrl: z.string().nullable(),
  decidedByEmail: z.email().nullable(),
  decidedAt: z.iso.datetime().nullable(),
  createdAt: z.iso.datetime(),
});
export type GlossaryProposal = z.infer<typeof GlossaryProposalSchema>;

export const GlossaryProposalListSchema = z.array(GlossaryProposalSchema);

export const ListGlossaryProposalsQuerySchema = z.object({
  status: GlossaryProposalStatusSchema.optional(),
});
export type ListGlossaryProposalsQuery = z.infer<typeof ListGlossaryProposalsQuerySchema>;
